import { AUTH_TOKEN_KEY } from './env'
import type { AuthSession } from '../types/auth'

const SESSION_KEY = 'hrs.auth.session'

export const authStorage = {
  getToken(): string | null {
    return localStorage.getItem(AUTH_TOKEN_KEY)
  },

  getSession(): AuthSession | null {
    const raw = localStorage.getItem(SESSION_KEY)

    if (!raw) {
      return null
    }

    try {
      return JSON.parse(raw) as AuthSession
    } catch {
      return null
    }
  },

  setSession(session: AuthSession): void {
    if (session.token) {
      localStorage.setItem(AUTH_TOKEN_KEY, session.token)
    }

    localStorage.setItem(SESSION_KEY, JSON.stringify(session))
  },

  clear(): void {
    localStorage.removeItem(AUTH_TOKEN_KEY)
    localStorage.removeItem(SESSION_KEY)
  },
}
